import React from "react";
import styles from "./SharedLoading.module.css";

interface SharedLoadingProps {
  size?: "small" | "medium" | "large";
  text?: string;
  color?: "primary" | "white";
  inline?: boolean;
}

const SharedLoading: React.FC<SharedLoadingProps> = ({
  size = "medium",
  text,
  color = "primary",
  inline = false,
}) => {
  return (
    <div className={`${styles.container} ${inline ? styles.inline : ""}`}>
      <div
        className={`${styles.spinner} ${styles[size]} ${styles[color]}`}
      ></div>
      {text && <div className={styles.text}>{text}</div>}
    </div>
  );
};

export default SharedLoading;
